import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { AuditableEntity } from '../viewmodels/auditable-entity';
import { AuthService } from './auth/auth.service';


@Injectable()
export class AuditEntityService {

  constructor(private loginService: AuthService) { }

  public auditNew(entity: AuditableEntity) {
    this.auditExisting(entity);
    entity.createdBy = entity.lastModifiedBy;
    entity.creationDate = entity.lastModifiedDate;
  }

  public auditExisting(entity: AuditableEntity) {
    this.loginService.loggedInUser.subscribe(data => {
      entity.lastModifiedBy = data;
    });
    entity.lastModifiedDate = moment().utc().format('YYYY-MM-DD HH:mm:ss');
  }
}
